import React, { useRef } from "react";
import { Autocomplete } from "@react-google-maps/api";

const AddressInput = ({ onAddressSelect, placeholderText }) => {
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current?.getPlace();

    if (!place) return;

    const formattedAddress = place.formatted_address || inputRef.current?.value || "";
    const lat = place.geometry?.location?.lat?.();
    const lng = place.geometry?.location?.lng?.();

    onAddressSelect({
      formatted_address: formattedAddress,
      lat,
      lng,
      place,
    });
  };

  return (
    <Autocomplete
      onLoad={(autocomplete) => {
        autocompleteRef.current = autocomplete;
        autocomplete.setFields(["formatted_address", "geometry", "place_id"]);
      }}
      onPlaceChanged={handlePlaceSelect}
      options={{
        componentRestrictions: { country: "fr" },
        types: ["address"],
      }}
    >
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholderText}
        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </Autocomplete>
  );
};

export default AddressInput;